import { useMemo } from "react";

import type { IntlShape } from "context/Intl";

import type { RegisterStep } from "./RegisterStepperProvider";

const KEY = "authentication.register";

export function useProviderRegisterSteps(intl: IntlShape): RegisterStep[] {
    return useMemo(
        () => [
            {
                key: "prestations",
                label: intl.formatMessage(`${KEY}.provider_flow.categories.label`),
                title: intl.formatMessage(`${KEY}.provider_flow.categories.aside.title`),
                description: intl.formatMessage(`${KEY}.provider_flow.categories.aside.description`),
                footnote: true
            },
            {
                key: "intervention",
                label: intl.formatMessage(`${KEY}.provider_flow.area.label`),
                title: intl.formatMessage(`${KEY}.provider_flow.area.aside.title`),
                description: intl.formatMessage(`${KEY}.provider_flow.area.aside.description`),
                footnote: true
            },
            {
                key: "informations",
                label: intl.formatMessage(`${KEY}.provider_flow.infos.label`),
                title: intl.formatMessage(`${KEY}.provider_flow.infos.aside.title`),
                description: intl.formatMessage(`${KEY}.provider_flow.infos.aside.description`),
                footnote: false
            },
            {
                key: "informations_profile",
                label: intl.formatMessage(`${KEY}.provider_flow.infos_profile.label`),
                title: intl.formatMessage(`${KEY}.provider_flow.infos_profile.aside.title`),
                description: intl.formatMessage(`${KEY}.provider_flow.infos_profile.aside.description`),
                footnote: false
            },
            {
                key: "photo",
                label: intl.formatMessage(`${KEY}.provider_flow.photo.label`), 
                title: intl.formatMessage(`${KEY}.provider_flow.photo.aside.title`),
                description: intl.formatMessage(`${KEY}.provider_flow.photo.aside.description`),
                footnote: false
            },
            {
                key: "cesu",
                label: intl.formatMessage(`${KEY}.provider_flow.cesu.label`),
                title: intl.formatMessage(`${KEY}.provider_flow.cesu.aside.title`),
                description: intl.formatMessage(`${KEY}.provider_flow.cesu.aside.description`),
                footnote: false
            },
            {
                key: "iban",
                label: intl.formatMessage(`${KEY}.provider_flow.iban.label`),  
                title: intl.formatMessage(`${KEY}.provider_flow.iban.aside.title`),
                description: intl.formatMessage(`${KEY}.provider_flow.iban.aside.description`),
                footnote: false
            },
            { key: "confirmation", label: "Confirmation" },
        ],
        [intl]
    );
}
